const numberFormatter = n => {
    if (isNaN(n)) n = parseFloat(n)
    let arr = n.toString().split('.')
    let prefix = ''
    if (arr[0].charAt(0) === '-') {
        prefix = '-'
        arr[0] = arr[0].substr(1)
    }
    let int = arr[0]
        .split('')
        .reverse()
        .join('')
    let aux = []
    for (let i = 0; i < int.length; i += 3) {
        aux.push(int.substr(i, 3))
    }
    arr[0] = aux
        .join('.')
        .split('')
        .reverse()
        .join('')
    return prefix + arr.join(',')
}
export default {
    methods: {
        mixCurrencyMask: function(value, maxLength) {
            value = String(value)
            let mask = '####'

            if (value.length > 3) {
                let counter = 0
                for (let i = 3; i < value.length; i++) {
                    if (counter == 0) mask = '.' + mask
                    counter++
                    mask = '#' + mask
                    if (counter > 2) counter = 0
                }
            }
            if (value.length == maxLength)
                mask = mask.substring(0, mask.length - 1)
            return '$' + mask
        },
        formatCurrency: numberFormatter,
        mixCurrencyFormatter: numberFormatter,
    },
    filters: {
        mixFormatCurrency: function(value) {
            if (value == 0) return '$ ' + value
            if (!value || isNaN(value)) return
            return '$' + numberFormatter(value)
        },
    },
}
